import { motion } from 'framer-motion'
import { Link as RouterLink } from 'react-router-dom'
// material
import { Box, Button, Container, Typography } from '@mui/material'
import { SeverErrorIllustration } from '../assets'
import { MotionContainer, varBounceIn } from '../components/library/animate'

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function PageError() {
  return (
    <Container>
      <MotionContainer initial="initial" open>
        <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
          <motion.div variants={varBounceIn}>
            <Typography variant="h3" paragraph>
              Page Error!!!
            </Typography>
          </motion.div>

          <motion.div variants={varBounceIn}>
            <SeverErrorIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
          </motion.div>

          <Button to="/" size="large" variant="contained" component={RouterLink}>
            Go to Home
          </Button>
        </Box>
      </MotionContainer>
    </Container>
  )
}
